/**
 * @file notificationSlice.js
 * @description Redux slice for managing notification data and route paths.
 * This file contains the actions and reducers related to notifications, such as setting
 * notification data and the notification route path. It also includes a reset state action.
 * @author Your Name
 */

import { createSlice } from '@reduxjs/toolkit';

// Initial state for the notification slice
const initialState = {
    notificationData: null,        // Holds the data for the notification
    notificationRoutePath: "/customnotification", // Default route path for notifications
    users : null, // Holds the user data related to notifications
};

// Creating the notification slice using Redux Toolkit
const notificationSlice = createSlice({
    name: 'notification', // Name of the slice in Redux store
    initialState,         // Initial state for the slice
    reducers: {
        /**
         * Set the notification data.
         * @param {Object} state - The current state.
         * @param {Object} action - The action containing the new notification data.
         */
        setNotificationData: (state, action) => {
            state.notificationData = action.payload; // Update notification data in the state
        },

        /**
         * Set the notification route path.
         * @param {Object} state - The current state.
         * @param {Object} action - The action containing the new route path.
         */
        setNotificationRoutePath: (state, action) => {
            state.notificationRoutePath = action.payload; // Update notification route path
        },
        setUsersData: (state, action) => {
            state.users = action.payload; // Update users data in the state
        }
    },

    /**
     * Extra reducers can be used to handle external actions (e.g., resetting the state).
     * Here, we are listening for a reset state action to reset the state back to its initial values.
     */
    extraReducers: (builder) => {
        builder.addCase('RESET_STATE', () => initialState); // Reset state when the 'RESET_STATE' action is dispatched
    }
});

// Exporting the actions generated by createSlice for use in dispatching
export const { setNotificationData, setNotificationRoutePath, setUsersData } = notificationSlice.actions;

// Exporting the reducer to be used in the store configuration
export default notificationSlice.reducer;
